<template>
  <v-dialog v-model="value" persistent max-width="500">
    <v-card>
      <v-card-title class="title font-weight-regular" v-if="!duzenle">
        <v-icon left color="black">mdi-account-plus</v-icon>
        {{ $t("KULLANICILAR.USER_ADD.ADD_NEW_USER_TITLE") }}
      </v-card-title>
      <v-card-title class="title font-weight-regular" v-else>
        <v-icon left color="black">mdi-account-plus</v-icon>
        {{ $t("KULLANICILAR.USER_ADD.UPDATE_USER_TITLE") }}
      </v-card-title>
      <v-card-text>
        <v-divider />
        <v-text-field v-model="kullaniciData.adSoyad" prepend-icon="mdi-account" :label="$t('KULLANICILAR.USER_ADD.INPUTS.NAME_SURNAME_LABEL')"></v-text-field>
        <v-text-field v-model="kullaniciData.eposta" prepend-icon="mdi-at" :label="$t('KULLANICILAR.USER_ADD.INPUTS.EMAIL_LABEL')"></v-text-field>
        <v-menu v-model="dogumTarihiMenu" ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted"
              :label="$t('KULLANICILAR.USER_ADD.INPUTS.BIRTHDAY_LABEL')"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              @blur="kullaniciData.dogumTarihi = parseDate(dateFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="kullaniciData.dogumTarihi"
            ref="picker"
            :max="new Date().toISOString().substr(0, 10)"
            min="1950-01-01"
            @change="dogumTarihiKaydet"
          ></v-date-picker>
        </v-menu>
        <div v-if="!duzenle">
          <v-text-field v-model="kullaniciData.sifre" prepend-icon="mdi-key" type="password" :label="$t('KULLANICILAR.USER_ADD.INPUTS.PASSWORD_LABEL')"></v-text-field>
          <v-text-field
            v-model="kullaniciData.sifreTekrar"
            prepend-icon="mdi-key"
            type="password"
            :label="$t('KULLANICILAR.USER_ADD.INPUTS.PASWORD_AGAIN_LABEL')"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions v-if="!duzenle">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" class="mr-1" text @click="dialogKapat">
          {{ $t("KULLANICILAR.USER_ADD.CANCEL_BTN") }}
        </v-btn>
        <v-btn color="blue" dark :loading="kullaniciEkleStatus" @click="kullaniciEkle">
          <v-icon left>mdi-plus-circle</v-icon>
          {{ $t("KULLANICILAR.USER_ADD.ADD_NEW_USER_BTN") }}
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" class="mr-1" text @click="dialogKapat">
          {{ $t("KULLANICILAR.USER_ADD.CANCEL_BTN") }}
        </v-btn>
        <v-btn color="success" dark :loading="kullaniciDuzenleStatus" @click="kullaniciDuzenle">
          <v-icon left>mdi-plus-circle</v-icon>
          {{ $t("KULLANICILAR.USER_ADD.UPDATE_USER_BTN") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import KullanicilarService from "@/services/KullanicilarService";
import { mapState } from "vuex";

export default {
  name: "KullaniciEkle",
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },
    duzenle: {
      required: false,
      default: false
    }
  },
  data: vm => ({
    kullaniciEkleStatus: false,
    kullaniciDuzenleStatus: false,
    kullaniciData: {
      adSoyad: "",
      eposta: "",
      dogumTarihi: new Date().toISOString().substr(0, 10),
      sifre: "",
      sifreTekrar: ""
    },
    dogumTarihiMenu: false,
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
  }),
  computed: {
    ...mapState({
      kullaniciListesi: state => state.Kullanicilar.KullaniciList.kullaniciListesi
    })
  },
  methods: {
    kullaniciEkle() {
      this.kullaniciEkleStatus = true;
      const { adSoyad, eposta, dogumTarihi, sifre, sifreTekrar } = this.kullaniciData;
      this.$store
        .dispatch("Kullanicilar/KullaniciList/kullaniciEkle", {
          adSoyad,
          eposta,
          dogumTarihi,
          sifre,
          sifreTekrar
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.USER_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.dialogSifirla();
            this.dialogKapat();
            /**
             * Kullanıcı ekleme işlemi başarılı döndüğünde
             * change eventi tetikle
             */
            this.$emit("change", {
              adSoyad,
              eposta,
              dogumTarihi,
              sifre,
              sifreTekrar
            });
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.kullaniciEkleStatus = false;
        });
    },
    /**
     * Herhangi bir kullanıcıyı düzenle
     *
     * Düzenleme tamamlandığında API'den dönen
     * güncel kullanıcı verisini al ve değişim yapılan
     * kullanıcıyı liste son aktif liste içerisinden
     * tespit et ve sadece onu değiştirip Store üzerineki
     * listeyi değiştirilen veri ile güncelle.
     *
     */
    kullaniciDuzenle() {
      this.kullaniciDuzenleStatus = true;
      const { kullaniciID, adSoyad, eposta, dogumTarihi } = this.kullaniciData;
      KullanicilarService.kullaniciDuzenle({
        kullaniciID,
        adSoyad,
        eposta,
        dogumTarihi
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.USER_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));

            const kullaniciDetay = res.data,
              kullaniciListesi = this.kullaniciListesi;
            /**
             * Son listeyi map'le
             */
            let yeniKullaniciListesi = kullaniciListesi.map(o => {
              if (o.id !== kullaniciDetay.id) {
                return o;
              } else return kullaniciDetay;
            });

            this.$store.commit("Kullanicilar/KullaniciList/setKullaniciListesi", yeniKullaniciListesi);

            this.dialogSifirla();
            this.dialogKapat();
          } else this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        })
        .then(() => {
          this.kullaniciDuzenleStatus = false;
        });
    },
    dialogSifirla() {
      this.kullaniciData.adSoyad = "";
      this.kullaniciData.eposta = "";
      this.kullaniciData.dogumTarihi = "";
      this.kullaniciData.sifre = "";
      this.kullaniciData.sifreTekrar = "";
      /**
       * Dialog sıfırlandığında bir event tetikle
       */
      this.$emit("update", this);
    },
    dialogKapat() {
      this.dialogSifirla();
      this.$emit("input", false);
    },
    dogumTarihiKaydet(date) {
      this.$refs.menu.save(date);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  watch: {
    dogumTarihiMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    "kullaniciData.dogumTarihi"(val) {
      this.dateFormatted = this.formatDate(val);
    },
    duzenle(val) {
      this.kullaniciData.kullaniciID = val.id;
      this.kullaniciData.adSoyad = val.name;
      this.kullaniciData.eposta = val.email;
      this.kullaniciData.dogumTarihi = val.birthday;
    }
  }
};
</script>

<style></style>
